/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as R404RouteImport } from './routes/404'
import { Route as ArcRouteImport } from './routes/arc'
import { Route as AuthRouteRouteImport } from './routes/auth/route'
import { Route as DashboardRouteRouteImport } from './routes/dashboard/route'
import { Route as MonitorRouteRouteImport } from './routes/monitor/route'
import { Route as ArcIndexRouteImport } from './routes/arc/index'
import { Route as ArcProfileRouteRouteImport } from './routes/arc/profile/route'
import { Route as ArcStatisticsRouteRouteImport } from './routes/arc/statistics/route'
import { Route as ArcStatusRouteRouteImport } from './routes/arc/status/route'
import { Route as AuthSignInRouteRouteImport } from './routes/auth/sign-in/route'
import { Route as AuthSuccessRouteRouteImport } from './routes/auth/success/route'
import { Route as ArcContactIdRouteImport } from './routes/arc/contact/$id'
import { Route as ArcStatusAdminRouteRouteImport } from './routes/arc/status/admin/route'
import { Route as ArcStatusAvailableRouteRouteImport } from './routes/arc/status/available/route'
import { Route as ArcStatusOfflineRouteRouteImport } from './routes/arc/status/offline/route'
import { Route as AuthActivationIndexRouteImport } from './routes/auth/activation/index'
import { Route as AuthCallbackMicrosoftRouteImport } from './routes/auth/callback/microsoft'
import { Route as AuthConfirmEmailChangeIndexRouteImport } from './routes/auth/confirm-email-change/index'
import { Route as AuthForgetPasswordIndexRouteImport } from './routes/auth/forget-password/index'
import { Route as AuthResetPasswordIndexRouteImport } from './routes/auth/reset-password/index'
import { Route as AuthWardenRegisterRouteRouteImport } from './routes/auth/warden/register/route'
import { Route as AuthWardenResetPasswordRouteRouteImport } from './routes/auth/warden/reset-password/route'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const R404Route = R404RouteImport.update({
  id: '/404',
  path: '/404',
  getParentRoute: () => rootRouteImport,
} as any)
const ArcRoute = ArcRouteImport.update({
  id: '/arc',
  path: '/arc',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRouteRoute = AuthRouteRouteImport.update({
  id: '/auth',
  path: '/auth',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRouteRoute = DashboardRouteRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const MonitorRouteRoute = MonitorRouteRouteImport.update({
  id: '/monitor',
  path: '/monitor',
  getParentRoute: () => rootRouteImport,
} as any)
const ArcIndexRoute = ArcIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ArcRoute,
} as any)
const ArcProfileRouteRoute = ArcProfileRouteRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => ArcRoute,
} as any)
const ArcStatisticsRouteRoute = ArcStatisticsRouteRouteImport.update({
  id: '/statistics',
  path: '/statistics',
  getParentRoute: () => ArcRoute,
} as any)
const ArcStatusRouteRoute = ArcStatusRouteRouteImport.update({
  id: '/status',
  path: '/status',
  getParentRoute: () => ArcRoute,
} as any)
const AuthSignInRouteRoute = AuthSignInRouteRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthSuccessRouteRoute = AuthSuccessRouteRouteImport.update({
  id: '/success',
  path: '/success',
  getParentRoute: () => AuthRouteRoute,
} as any)
const ArcContactIdRoute = ArcContactIdRouteImport.update({
  id: '/contact/$id',
  path: '/contact/$id',
  getParentRoute: () => ArcRoute,
} as any)
const ArcStatusAdminRouteRoute = ArcStatusAdminRouteRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => ArcStatusRouteRoute,
} as any)
const ArcStatusAvailableRouteRoute = ArcStatusAvailableRouteRouteImport.update({
  id: '/available',
  path: '/available',
  getParentRoute: () => ArcStatusRouteRoute,
} as any)
const ArcStatusOfflineRouteRoute = ArcStatusOfflineRouteRouteImport.update({
  id: '/offline',
  path: '/offline',
  getParentRoute: () => ArcStatusRouteRoute,
} as any)
const AuthActivationIndexRoute = AuthActivationIndexRouteImport.update({
  id: '/activation/',
  path: '/activation/',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthCallbackMicrosoftRoute = AuthCallbackMicrosoftRouteImport.update({
  id: '/callback/microsoft',
  path: '/callback/microsoft',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthConfirmEmailChangeIndexRoute =
  AuthConfirmEmailChangeIndexRouteImport.update({
    id: '/confirm-email-change/',
    path: '/confirm-email-change/',
    getParentRoute: () => AuthRouteRoute,
  } as any)
const AuthForgetPasswordIndexRoute = AuthForgetPasswordIndexRouteImport.update({
  id: '/forget-password/',
  path: '/forget-password/',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthResetPasswordIndexRoute = AuthResetPasswordIndexRouteImport.update({
  id: '/reset-password/',
  path: '/reset-password/',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthWardenRegisterRouteRoute = AuthWardenRegisterRouteRouteImport.update({
  id: '/warden/register',
  path: '/warden/register',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthWardenResetPasswordRouteRoute =
  AuthWardenResetPasswordRouteRouteImport.update({
    id: '/warden/reset-password',
    path: '/warden/reset-password',
    getParentRoute: () => AuthRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/auth': typeof AuthRouteRouteWithChildren
  '/dashboard': typeof DashboardRouteRoute
  '/monitor': typeof MonitorRouteRoute
  '/404': typeof R404Route
  '/arc': typeof ArcRouteWithChildren
  '/arc/profile': typeof ArcProfileRouteRoute
  '/arc/statistics': typeof ArcStatisticsRouteRoute
  '/arc/status': typeof ArcStatusRouteRouteWithChildren
  '/auth/sign-in': typeof AuthSignInRouteRoute
  '/auth/success': typeof AuthSuccessRouteRoute
  '/arc/': typeof ArcIndexRoute
  '/arc/status/admin': typeof ArcStatusAdminRouteRoute
  '/arc/status/available': typeof ArcStatusAvailableRouteRoute
  '/arc/status/offline': typeof ArcStatusOfflineRouteRoute
  '/auth/warden/register': typeof AuthWardenRegisterRouteRoute
  '/auth/warden/reset-password': typeof AuthWardenResetPasswordRouteRoute
  '/arc/contact/$id': typeof ArcContactIdRoute
  '/auth/callback/microsoft': typeof AuthCallbackMicrosoftRoute
  '/auth/activation/': typeof AuthActivationIndexRoute
  '/auth/confirm-email-change/': typeof AuthConfirmEmailChangeIndexRoute
  '/auth/forget-password/': typeof AuthForgetPasswordIndexRoute
  '/auth/reset-password/': typeof AuthResetPasswordIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/auth': typeof AuthRouteRouteWithChildren
  '/dashboard': typeof DashboardRouteRoute
  '/monitor': typeof MonitorRouteRoute
  '/404': typeof R404Route
  '/arc/profile': typeof ArcProfileRouteRoute
  '/arc/statistics': typeof ArcStatisticsRouteRoute
  '/arc/status': typeof ArcStatusRouteRouteWithChildren
  '/auth/sign-in': typeof AuthSignInRouteRoute
  '/auth/success': typeof AuthSuccessRouteRoute
  '/arc': typeof ArcIndexRoute
  '/arc/status/admin': typeof ArcStatusAdminRouteRoute
  '/arc/status/available': typeof ArcStatusAvailableRouteRoute
  '/arc/status/offline': typeof ArcStatusOfflineRouteRoute
  '/auth/warden/register': typeof AuthWardenRegisterRouteRoute
  '/auth/warden/reset-password': typeof AuthWardenResetPasswordRouteRoute
  '/arc/contact/$id': typeof ArcContactIdRoute
  '/auth/callback/microsoft': typeof AuthCallbackMicrosoftRoute
  '/auth/activation': typeof AuthActivationIndexRoute
  '/auth/confirm-email-change': typeof AuthConfirmEmailChangeIndexRoute
  '/auth/forget-password': typeof AuthForgetPasswordIndexRoute
  '/auth/reset-password': typeof AuthResetPasswordIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/auth': typeof AuthRouteRouteWithChildren
  '/dashboard': typeof DashboardRouteRoute
  '/monitor': typeof MonitorRouteRoute
  '/404': typeof R404Route
  '/arc': typeof ArcRouteWithChildren
  '/arc/profile': typeof ArcProfileRouteRoute
  '/arc/statistics': typeof ArcStatisticsRouteRoute
  '/arc/status': typeof ArcStatusRouteRouteWithChildren
  '/auth/sign-in': typeof AuthSignInRouteRoute
  '/auth/success': typeof AuthSuccessRouteRoute
  '/arc/': typeof ArcIndexRoute
  '/arc/status/admin': typeof ArcStatusAdminRouteRoute
  '/arc/status/available': typeof ArcStatusAvailableRouteRoute
  '/arc/status/offline': typeof ArcStatusOfflineRouteRoute
  '/auth/warden/register': typeof AuthWardenRegisterRouteRoute
  '/auth/warden/reset-password': typeof AuthWardenResetPasswordRouteRoute
  '/arc/contact/$id': typeof ArcContactIdRoute
  '/auth/callback/microsoft': typeof AuthCallbackMicrosoftRoute
  '/auth/activation/': typeof AuthActivationIndexRoute
  '/auth/confirm-email-change/': typeof AuthConfirmEmailChangeIndexRoute
  '/auth/forget-password/': typeof AuthForgetPasswordIndexRoute
  '/auth/reset-password/': typeof AuthResetPasswordIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/auth'
    | '/dashboard'
    | '/monitor'
    | '/404'
    | '/arc'
    | '/arc/profile'
    | '/arc/statistics'
    | '/arc/status'
    | '/auth/sign-in'
    | '/auth/success'
    | '/arc/'
    | '/arc/status/admin'
    | '/arc/status/available'
    | '/arc/status/offline'
    | '/auth/warden/register'
    | '/auth/warden/reset-password'
    | '/arc/contact/$id'
    | '/auth/callback/microsoft'
    | '/auth/activation/'
    | '/auth/confirm-email-change/'
    | '/auth/forget-password/'
    | '/auth/reset-password/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/auth'
    | '/dashboard'
    | '/monitor'
    | '/404'
    | '/arc/profile'
    | '/arc/statistics'
    | '/arc/status'
    | '/auth/sign-in'
    | '/auth/success'
    | '/arc'
    | '/arc/status/admin'
    | '/arc/status/available'
    | '/arc/status/offline'
    | '/auth/warden/register'
    | '/auth/warden/reset-password'
    | '/arc/contact/$id'
    | '/auth/callback/microsoft'
    | '/auth/activation'
    | '/auth/confirm-email-change'
    | '/auth/forget-password'
    | '/auth/reset-password'
  id:
    | '__root__'
    | '/'
    | '/auth'
    | '/dashboard'
    | '/monitor'
    | '/404'
    | '/arc'
    | '/arc/profile'
    | '/arc/statistics'
    | '/arc/status'
    | '/auth/sign-in'
    | '/auth/success'
    | '/arc/'
    | '/arc/status/admin'
    | '/arc/status/available'
    | '/arc/status/offline'
    | '/auth/warden/register'
    | '/auth/warden/reset-password'
    | '/arc/contact/$id'
    | '/auth/callback/microsoft'
    | '/auth/activation/'
    | '/auth/confirm-email-change/'
    | '/auth/forget-password/'
    | '/auth/reset-password/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthRouteRoute: typeof AuthRouteRouteWithChildren
  DashboardRouteRoute: typeof DashboardRouteRoute
  MonitorRouteRoute: typeof MonitorRouteRoute
  R404Route: typeof R404Route
  ArcRoute: typeof ArcRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/404': {
      id: '/404'
      path: '/404'
      fullPath: '/404'
      preLoaderRoute: typeof R404RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/arc': {
      id: '/arc'
      path: '/arc'
      fullPath: '/arc'
      preLoaderRoute: typeof ArcRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth': {
      id: '/auth'
      path: '/auth'
      fullPath: '/auth'
      preLoaderRoute: typeof AuthRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard': {
      id: '/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/monitor': {
      id: '/monitor'
      path: '/monitor'
      fullPath: '/monitor'
      preLoaderRoute: typeof MonitorRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/arc/': {
      id: '/arc/'
      path: '/'
      fullPath: '/arc/'
      preLoaderRoute: typeof ArcIndexRouteImport
      parentRoute: typeof ArcRoute
    }
    '/arc/profile': {
      id: '/arc/profile'
      path: '/profile'
      fullPath: '/arc/profile'
      preLoaderRoute: typeof ArcProfileRouteRouteImport
      parentRoute: typeof ArcRoute
    }
    '/arc/statistics': {
      id: '/arc/statistics'
      path: '/statistics'
      fullPath: '/arc/statistics'
      preLoaderRoute: typeof ArcStatisticsRouteRouteImport
      parentRoute: typeof ArcRoute
    }
    '/arc/status': {
      id: '/arc/status'
      path: '/status'
      fullPath: '/arc/status'
      preLoaderRoute: typeof ArcStatusRouteRouteImport
      parentRoute: typeof ArcRoute
    }
    '/auth/sign-in': {
      id: '/auth/sign-in'
      path: '/sign-in'
      fullPath: '/auth/sign-in'
      preLoaderRoute: typeof AuthSignInRouteRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/auth/success': {
      id: '/auth/success'
      path: '/success'
      fullPath: '/auth/success'
      preLoaderRoute: typeof AuthSuccessRouteRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/arc/contact/$id': {
      id: '/arc/contact/$id'
      path: '/contact/$id'
      fullPath: '/arc/contact/$id'
      preLoaderRoute: typeof ArcContactIdRouteImport
      parentRoute: typeof ArcRoute
    }
    '/arc/status/admin': {
      id: '/arc/status/admin'
      path: '/admin'
      fullPath: '/arc/status/admin'
      preLoaderRoute: typeof ArcStatusAdminRouteRouteImport
      parentRoute: typeof ArcStatusRouteRoute
    }
    '/arc/status/available': {
      id: '/arc/status/available'
      path: '/available'
      fullPath: '/arc/status/available'
      preLoaderRoute: typeof ArcStatusAvailableRouteRouteImport
      parentRoute: typeof ArcStatusRouteRoute
    }
    '/arc/status/offline': {
      id: '/arc/status/offline'
      path: '/offline'
      fullPath: '/arc/status/offline'
      preLoaderRoute: typeof ArcStatusOfflineRouteRouteImport
      parentRoute: typeof ArcStatusRouteRoute
    }
    '/auth/activation/': {
      id: '/auth/activation/'
      path: '/activation'
      fullPath: '/auth/activation/'
      preLoaderRoute: typeof AuthActivationIndexRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/auth/callback/microsoft': {
      id: '/auth/callback/microsoft'
      path: '/callback/microsoft'
      fullPath: '/auth/callback/microsoft'
      preLoaderRoute: typeof AuthCallbackMicrosoftRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/auth/confirm-email-change/': {
      id: '/auth/confirm-email-change/'
      path: '/confirm-email-change'
      fullPath: '/auth/confirm-email-change/'
      preLoaderRoute: typeof AuthConfirmEmailChangeIndexRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/auth/forget-password/': {
      id: '/auth/forget-password/'
      path: '/forget-password'
      fullPath: '/auth/forget-password/'
      preLoaderRoute: typeof AuthForgetPasswordIndexRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/auth/reset-password/': {
      id: '/auth/reset-password/'
      path: '/reset-password'
      fullPath: '/auth/reset-password/'
      preLoaderRoute: typeof AuthResetPasswordIndexRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/auth/warden/register': {
      id: '/auth/warden/register'
      path: '/warden/register'
      fullPath: '/auth/warden/register'
      preLoaderRoute: typeof AuthWardenRegisterRouteRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/auth/warden/reset-password': {
      id: '/auth/warden/reset-password'
      path: '/warden/reset-password'
      fullPath: '/auth/warden/reset-password'
      preLoaderRoute: typeof AuthWardenResetPasswordRouteRouteImport
      parentRoute: typeof AuthRouteRoute
    }
  }
}

interface AuthRouteRouteChildren {
  AuthSignInRouteRoute: typeof AuthSignInRouteRoute
  AuthSuccessRouteRoute: typeof AuthSuccessRouteRoute
  AuthWardenRegisterRouteRoute: typeof AuthWardenRegisterRouteRoute
  AuthWardenResetPasswordRouteRoute: typeof AuthWardenResetPasswordRouteRoute
  AuthCallbackMicrosoftRoute: typeof AuthCallbackMicrosoftRoute
  AuthActivationIndexRoute: typeof AuthActivationIndexRoute
  AuthConfirmEmailChangeIndexRoute: typeof AuthConfirmEmailChangeIndexRoute
  AuthForgetPasswordIndexRoute: typeof AuthForgetPasswordIndexRoute
  AuthResetPasswordIndexRoute: typeof AuthResetPasswordIndexRoute
}

const AuthRouteRouteChildren: AuthRouteRouteChildren = {
  AuthSignInRouteRoute: AuthSignInRouteRoute,
  AuthSuccessRouteRoute: AuthSuccessRouteRoute,
  AuthWardenRegisterRouteRoute: AuthWardenRegisterRouteRoute,
  AuthWardenResetPasswordRouteRoute: AuthWardenResetPasswordRouteRoute,
  AuthCallbackMicrosoftRoute: AuthCallbackMicrosoftRoute,
  AuthActivationIndexRoute: AuthActivationIndexRoute,
  AuthConfirmEmailChangeIndexRoute: AuthConfirmEmailChangeIndexRoute,
  AuthForgetPasswordIndexRoute: AuthForgetPasswordIndexRoute,
  AuthResetPasswordIndexRoute: AuthResetPasswordIndexRoute,
}

const AuthRouteRouteWithChildren = AuthRouteRoute._addFileChildren(
  AuthRouteRouteChildren,
)

interface ArcStatusRouteRouteChildren {
  ArcStatusAdminRouteRoute: typeof ArcStatusAdminRouteRoute
  ArcStatusAvailableRouteRoute: typeof ArcStatusAvailableRouteRoute
  ArcStatusOfflineRouteRoute: typeof ArcStatusOfflineRouteRoute
}

const ArcStatusRouteRouteChildren: ArcStatusRouteRouteChildren = {
  ArcStatusAdminRouteRoute: ArcStatusAdminRouteRoute,
  ArcStatusAvailableRouteRoute: ArcStatusAvailableRouteRoute,
  ArcStatusOfflineRouteRoute: ArcStatusOfflineRouteRoute,
}

const ArcStatusRouteRouteWithChildren = ArcStatusRouteRoute._addFileChildren(
  ArcStatusRouteRouteChildren,
)

interface ArcRouteChildren {
  ArcProfileRouteRoute: typeof ArcProfileRouteRoute
  ArcStatisticsRouteRoute: typeof ArcStatisticsRouteRoute
  ArcStatusRouteRoute: typeof ArcStatusRouteRouteWithChildren
  ArcIndexRoute: typeof ArcIndexRoute
  ArcContactIdRoute: typeof ArcContactIdRoute
}

const ArcRouteChildren: ArcRouteChildren = {
  ArcProfileRouteRoute: ArcProfileRouteRoute,
  ArcStatisticsRouteRoute: ArcStatisticsRouteRoute,
  ArcStatusRouteRoute: ArcStatusRouteRouteWithChildren,
  ArcIndexRoute: ArcIndexRoute,
  ArcContactIdRoute: ArcContactIdRoute,
}

const ArcRouteWithChildren = ArcRoute._addFileChildren(ArcRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthRouteRoute: AuthRouteRouteWithChildren,
  DashboardRouteRoute: DashboardRouteRoute,
  MonitorRouteRoute: MonitorRouteRoute,
  R404Route: R404Route,
  ArcRoute: ArcRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
